module.exports = __webpack_public_path__ + "static/art-direction-c6462bdc2282d04fc3b51bb66294f492.jpeg";